import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=3658d101&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=3658d101&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3658d101",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\taiqiu\\back-end\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3658d101')) {
      api.createRecord('3658d101', component.options)
    } else {
      api.reload('3658d101', component.options)
    }
    module.hot.accept("./Menu.vue?vue&type=template&id=3658d101&scoped=true&", function () {
      api.rerender('3658d101', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Navbar/Menu.vue"
export default component.exports